import { render, staticRenderFns } from "./AbilityScoreRow.vue?vue&type=template&id=881d4008"
import script from "./AbilityScoreRow.vue?vue&type=script&lang=js"
export * from "./AbilityScoreRow.vue?vue&type=script&lang=js"
import style0 from "./AbilityScoreRow.vue?vue&type=style&index=0&id=881d4008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports